function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function throttle(func, timeFrame) {
  var lastTime = 0;
  return function () {
    var now = new Date();
    if (now - lastTime >= timeFrame) {
      func();
      lastTime = now;
    }
  };
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    const amountInput = this.querySelector(".quantity__input");

    amountInput.addEventListener("keyup", () => {
      this.onInputKeyDown();
    });

    // Reset the product amount input value to 1 when it is empty or '0'
    amountInput.addEventListener("blur", () => {
      if (!amountInput.value || amountInput.value == 0) {
        amountInput.value = 1;
        this.updateProductPrice();
      }
    });
  }

  onInputChange(event) {
    if (!this.input) {
      return;
    }
    // update the price on the sale button if we have one
    this.updateProductPrice();
  }

  onInputKeyDown() {
    if (this.input.value !== "") {
      this.updateProductPrice();
    }
  }

  updateProductPrice() {
    const productWrapper = this.input.closest(".product__info-wrapper");
    // Select the script tag with the data-bsub-money-format attribute
    const scriptTag = document.querySelector("script[data-bsub-money-format]");

    // Get the value of the data-bsub-money-format attribute
    const moneyFormat = scriptTag.getAttribute("data-bsub-money-format");

    // Extract the currency symbol using a regular expression
    const currency = moneyFormat.match(/^[^\d{]+/);
    const currencySymbol = currency[0];

    if (productWrapper) {
      const productPriceWrapper = productWrapper.querySelector(
        ".product-form__submit strong"
      );

      if (productPriceWrapper) {
        const variantPrice = productWrapper.querySelector(
          "[name=variant_price]"
        ).value;
        let numericValue;
        let currencyString;
        let numberValue;

        if (variantPrice.startsWith(currencySymbol)) {
          numericValue = variantPrice
            .replace(currencySymbol, "")
            .trim()
            .replace(/,/g, "");
        }

        const totalPrice = Clinicians.formatPrice(
          numericValue * 100 * this.input.value
        );

        currencyString = totalPrice.replace("$", "").trim();
        // Convert the string to a number
        numberValue = parseFloat(currencyString).toFixed(2);
        numberValue.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        productPriceWrapper.innerHTML = currencySymbol + numberValue;
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();

    if (!this.input) return;

    const previousValue = this.input.value;

    if (previousValue.toString() === "1" && event.target.name === "minus") {
      return;
    }

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    // update the price on the sale button if we have one
    this.updateProductPrice();
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    // Adjust header bottom position so mega menu does not include promo banner height
    const promoBar =
      this.header.querySelector(".promo-bar") ||
      document.querySelector(".promo-bar");
    const promoHeight =
      promoBar && !promoBar.classList.contains("is-hidden")
        ? promoBar.getBoundingClientRect().height
        : 0;
    const headerBottom =
      this.header.getBoundingClientRect().bottom -
      this.borderOffset -
      promoHeight;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(headerBottom)}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("load", this.renderPreSelectedPrice());
    this.addEventListener("change", this.onVariantChange);
  }

  /**
   * Format the price. e.g: 3200 => $32.00
   * @param {*} number
   * @returns
   */
  formatAsCurrency(number) {
    const scriptTag = document.querySelector("script[data-bsub-money-format]");
    // Get the value of the data-bsub-money-format attribute
    const moneyFormat = scriptTag.getAttribute("data-bsub-money-format");
    // Extract the currency symbol using a regular expression
    const currency = moneyFormat.match(/^[^\d{]+/);
    const currencySymbol = currency[0];
    const currencyFormatted = (number / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    const currencyString = currencyFormatted.replace("$", "").trim();
    const localCurrencyString = currencySymbol + currencyString;

    return localCurrencyString;
  }

  renderPreSelectedPrice() {
    this.updateOptions();
    const preSelectedVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    const oneTimePurchasePriceField = document.querySelector(
      ".bsub-widget__group-header--one-time-purchase .bsub-widget__price"
    );
    const sideCart = document.querySelector(".side-cart");
    if (preSelectedVariant && !sideCart.classList.contains("in")) {
      const preSelectedVariantPrice = this.formatAsCurrency(
        preSelectedVariant.price
      );
      oneTimePurchasePriceField.innerHTML = preSelectedVariantPrice;
    }
  }

  onVariantChange(e) {
    // if the variant change has happened on the cart items (side cart or full)
    // then we need to do a few different things, we need to first check that
    // it is in stock, and if so then we need to update the cart item with the
    // new variant id
    this.updateOptions();

    const selectedVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if (selectedVariant) {
      // hide dose
      const doses = document.querySelectorAll(
        ".product__info-dose[data-variant-id]"
      );

      doses.forEach((dose) => {
        if (dose.dataset.variantId == selectedVariant.id) {
          dose.classList.add("active");
          dose.classList.remove("hidden");
        } else {
          dose.classList.remove("active");
          dose.classList.add("hidden");
        }
      });
    }

    if (e.target.closest("cart-items")) {
      e.preventDefault();

      if (!selectedVariant || !selectedVariant.available) {
        alert("This variant is not available for purchase");

        // change back to the first variant that is available
        const firstAvailableVariant = this.getVariantData().find(
          (variant) => variant.available
        );

        if (firstAvailableVariant) {
          this.currentVariant = firstAvailableVariant;
          this.options = firstAvailableVariant.options;
          this.updateOptions();
        }

        return false;
      }

      // available so remove the current line item and add the new one
      const row = e.target.closest("tr");
      const quantity = e.target
        .closest("tr")
        .querySelector(".quantity__input").value;

      var side = row.closest(".side-cart__inner");

      if (side) {
        side.classList.add("side-cart__inner--loading");
        side.innerHTML = '<div class="dot-pulse"></div>';
      }

      // remove the old one from the cart and add the new one
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: row.dataset.key,
          quantity: 0,
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          console.log("now we adding!");
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: selectedVariant.id,
              quantity: quantity,
            }),
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (data) {
              if (side) {
                Clinicians.showSidecart();
              } else {
                window.location.reload();
              }
            });
        });

      // done. Don't continue with the rest of the function which is for the
      // product page
      return false;
    }

    if (selectedVariant) {
      document.querySelector("[name=id]").value = selectedVariant.id;
      const updatedPrice = Clinicians.formatPrice(selectedVariant.price);
      const variantPrice = document.querySelector("[name=variant_price]");

      if (variantPrice) {
        variantPrice.value = updatedPrice;
      }

      // Update One-time purchase price after product size is changed.
      const oneTimePurchasePriceField = document.querySelector(
        ".bsub-widget__group-header--one-time-purchase .bsub-widget__price"
      );

      if (oneTimePurchasePriceField) {
        oneTimePurchasePriceField.innerHTML = updatedPrice;
      }
    }

    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {}

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") {
      return;
    }

    // update the url with the new variant id
    const url = new URL(window.location.href);
    url.searchParams.set("variant", this.currentVariant.id);

    if (window.history.replaceState) {
      window.history.replaceState(null, "", url);
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("visibility-hidden");

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
          true
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (productForm) {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      const addButtonPrice = productForm.querySelector('[name="add"] > strong');

      if (addButton) {
        if (disable) {
          addButton.setAttribute("disabled", "disabled");

          if (text) {
            addButtonText.textContent = text;
          }
        } else {
          addButton.removeAttribute("disabled");
          const checkSubscribeButton = document.querySelector
          ('.bsub-widget__input[data-bsub-selling-plan-group-input]').checked;

          if (checkSubscribeButton) {
            const subscribePrice = document.querySelector('.bsub-widget__group-discount-summary');
            addButtonPrice.textContent = subscribePrice.innerHTML;
          } else {
            addButtonPrice.textContent = document.querySelector(
              "[name=variant_price]"
            ).value;
          }

          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }

    const addToCartBar = document.querySelector(".product-bar__add a");

    if (addToCartBar) {
      if (disable) {
        addToCartBar.setAttribute("disabled", "disabled");
        addToCartBar.classList.add("disabled");

        if (text) {
          addToCartBar.querySelector("span").textContent = text;
        }
      } else {
        addToCartBar.removeAttribute("disabled");
        addToCartBar.classList.remove("disabled");
        addToCartBar.querySelector("strong").textContent =
          document.querySelector("[name=variant_price]").value;
        addToCartBar.querySelector("span").textContent =
          window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) {
      return;
    }
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (button) {
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');

      if (addButton) {
        addButtonText.textContent = window.variantStrings.unavailable;
      }
    }

    const price = document.getElementById(`price-${this.dataset.section}`);

    if (price) {
      price.classList.add("visibility-hidden");
    }

    // mark the promo bar as sold out
    const addToCartBar = document.querySelector(".product-bar__add a");
    if (addToCartBar) {
      addToCartBar.textContent = window.variantStrings.unavailable;
      addToCartBar.classList.add("disabled");
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getVariantSelectedId() {
    if (this.currentVariant && this.currentVariant.available) {
      return this.currentVariant.id;
    }

    var variants = this.getVariantData();
    var variantId = 0;

    variants.forEach((variant) => {
      if (variant.available && !variantId) {
        variantId = variant.id;
      }
    });

    return variantId;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);
